/* SWAY theme JS — progressive enhancement only.
   Saved products (local-device wishlist). Not synced to any account.
   Guarded against duplicate listeners on theme-editor section reloads. */
(function () {
  'use strict';
  var STORAGE_KEY = 'sway_saved_products_v1';

  function readSaved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeSaved(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) { /* storage unavailable: fail silently */ }
  }

  function refreshButtons(scope) {
    var saved = readSaved();
    (scope || document).querySelectorAll('[data-sway-save]').forEach(function (btn) {
      var id = btn.getAttribute('data-sway-save');
      var on = saved.indexOf(id) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function onClick(event) {
    var btn = event.target.closest('[data-sway-save]');
    if (!btn) return;
    var id = btn.getAttribute('data-sway-save');
    var saved = readSaved();
    var i = saved.indexOf(id);
    if (i === -1) { saved.push(id); } else { saved.splice(i, 1); }
    writeSaved(saved);
    refreshButtons(document);
    document.dispatchEvent(new CustomEvent('sway:saved-changed', { detail: { saved: saved } }));
  }

  function onSavedPage() {
    var list = document.querySelector('[data-sway-saved-list]');
    if (!list) return;
    var empty = document.querySelector('[data-sway-saved-empty]');
    var render = function () {
      var saved = readSaved();
      list.innerHTML = '';
      if (!saved.length) {
        list.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      list.hidden = false;
      if (empty) empty.hidden = true;
      saved.forEach(function (handle) {
        var li = document.createElement('li');
        li.className = 'sway-saved-item';
        var a = document.createElement('a');
        a.href = '/products/' + encodeURIComponent(handle);
        a.textContent = handle;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sway-save-btn';
        remove.setAttribute('data-sway-save', handle);
        remove.setAttribute('aria-pressed', 'true');
        remove.setAttribute('aria-label', 'Remove');
        remove.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        li.appendChild(a);
        li.appendChild(remove);
        list.appendChild(li);
      });
    };
    render();
    document.addEventListener('sway:saved-changed', render);
  }

  function init() {
    if (document.documentElement.hasAttribute('data-sway-init')) return;
    document.documentElement.setAttribute('data-sway-init', '1');
    document.addEventListener('click', onClick);
    document.addEventListener('shopify:section:load', function (e) { refreshButtons(e.target); });
    refreshButtons(document);
    onSavedPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
